import { LawYear } from "@/types/salary";

export const DEFAULT_LAW_YEAR = LawYear.TWENTY_SIX;
